//-----------------------------------
// quickAdd.js
// Quick add product to cart from dropdown
//-----------------------------------

import $ from 'jquery'
import Vue from 'vue';
import axios from 'axios'
import { store } from '../../vuex/store';
import { TweenMax, TweenLite, Power2 } from 'gsap';

let the_vues = []


// Bundle Vue Data
const dataDefault = {
    handle: 'og handle',
    title: 'Test Title',
    productData: {},
    is_diff_size: true,
    qty_to_add: 1,
    added: false,
    same_sizes: [],
    diff_sizes: [],
    diff_types: [],
    the_sizes: [],
    grouped_variants:[],
    ungrouped_variants: [],
    selected_size: '',
    selected_sizes: [],
    addToCartText: 'Select A Size',
    tops_group: [ 'chemise','cami'],
    tops: [],
    bottoms_group: ['hi leg','bikini','hipster','thong','cheeky','boyshort','tanga','shorty','hikini'],
    bottoms: [],
    bras_group: ['t-shirt','push up','contour','underwire','balconette','strapless','plunge'],
    bras: [],
    bralettes_group: [ 'bralette', 'wire free' ],
    bralettes: [],
    misc_group: ['accessories', 'bodysuit', 'garter belts'],
    misc: [],
    loadComplete: false
}
// sisterSize 
// ---------------------------------------
export let quickAdd = {

	init() {
        console.log('QUICKADD! ')
        quickAdd.mobileQuick();
        quickAdd.createBundleDrop()
        if ($(window).width() >= 1024) {
            quickAdd.desktopQuick();
        }
        quickAdd.swatches()
	},
    mobileQuick() {
    $('.js-ProductGridItemNew-select').on('focus blur', function(event) {
      $('meta[name=viewport]').attr(
        'content',
        'width=device-width,initial-scale=1,maximum-scale=1'
      );
    });
    $('.js-ProductGridItemNew-select').change(function(e) {
        // $('meta[name=viewport]').attr('content', 'width=device-width,initial-scale=1,maximum-scale=1');
        // if we're dealing with a bundle 
        let variant = this.value
        if($(this).attr('data-bundle') === "true"){
            
        }else{
              console.log('change event');
              let the_select_menu = $(this);
              let mobilebtn = $(this).siblings('.js-ProductGridItemNew-quick');
              let the_button_size = $(this)
                .siblings('.js-ProductGridItemNew-quick')
                .children('strong');
              let the_variant_id = $(this)
                .find(':selected')
                .val();
              let the_variant_title = $(this)
                .find(':selected')
                .attr('data-title')
                .trim();
              let the_product_handle = $(this)
              .closest('.ProductGridItemNew')
              .attr('data-handle');
              let the_sku = $(this)
                .find(':selected')
                .attr('data-sku');
              let the_price = $(this)
                .find(':selected')
                .attr('data-price');
              let the_product = $(this)
                .closest('.js-ProductGridItemNew-select')
                .attr('data-handle');
              let is_preorder = $(this)
              .find(':selected')
              .attr('data-preorder');   
        
              
              // New Add to Cart non bndle
              // Declare paylod obj 
              let payload;
              // Check if it's a kit
              if($(this).closest('.ProductGridItemNew').attr('data-is-kit') === 'true' ){
                // If its a kit, grab the items and format them for line item props
                let the_kit_items = $(this).closest('.ProductGridItemNew').find('.ProductGridItemNew-kitItems').text();
                let the_kit_items_obj = the_kit_items.split("|").reduce(function(obj, value, index) {
                
                  let the_kit_num = 'kit_item'+index
                  if (the_kit_num && value) { //<-- Make sure the key & value are not undefined
                    obj[the_kit_num] = value.trim(); //<-- Get rid of extra spaces at beginning of value strings
                  }
                  return obj;
                }, {});

               // add hidden jam
                the_kit_items_obj["_kit"] = true;
              
                console.log(the_kit_items_obj);
                payload = {
                  id: parseInt(the_variant_id),
                  props: { quantity: 1, properties: the_kit_items_obj },
                };
              }else if( is_preorder === 'true' ){
                // let the_sku = $(this).find(':selected').attr('data-sku');
                let preorder_date = $(this)
                .find(':selected')
                .attr('data-preorderdate'); 
                payload = {
                  id: parseInt(the_variant_id),
                  props: { 
                    quantity: 1,
                    properties: { "_preorder": true, "_preorderDate": preorder_date },
                  },
                };
              }else{
                payload = {
                  id: parseInt(the_variant_id),
                  props: { quantity: 1 },
                };
              }
              store.dispatch('cart/addItem', payload).then(function(){
                console.log('done');
                the_button_size.text(the_variant_title+" ");
                console.log('show');
                TweenLite.to( mobilebtn, 0.1, { autoAlpha: 1, display:'block', ease: Power2.ease } );
                TweenLite.to( the_select_menu, 0.1, { autoAlpha: 0, display:'none', ease: Power2.ease } );
                console.log('delay');
                the_select_menu[0].selectedIndex = 0;
                TweenLite.to( mobilebtn, 0.1, {  autoAlpha: 0, display:'none', ease: Power2.ease, delay:1.25 } );
                TweenLite.to( the_select_menu, 0.1, {  autoAlpha: 1, display:'block', ease: Power2.ease, delay:1.25} );

                let theEventName = 'Quick Add - Added Product'
                let quickAddType = 'default'
                if(typeof the_select_menu.data('eventname') !== 'undefined'){
                    theEventName = 'Quick Add - ' + the_select_menu.data('eventname');
                    quickAddType = the_select_menu.data('eventname');
                }
                
               
                //GA4
                console.log("SINGLE ADD ")
                let eventType = e.target.attributes['data-eventname'].value

                $.get(`/products/${the_product_handle}.js`)
                    .done(response => {
                        console.log("RESPONSE FROM prod.js")
                        const data = JSON.parse(response)
                        const title = data.title
                        const productTitle = title.slice(0, title.indexOf(':'))
                        let color = title.slice(title.indexOf(':') + 2)
                        gtag('event', 'added_prod', {
                            'product': productTitle,
                            'variant': the_variant_title,
                            'color' : color,
                            'type': eventType,
                            'Bundle': false
                        })
                    })
                    .fail(() => {
                        console.log("COULDNT GET")
                    })
              });
        }
       
    });//end of change 
    },
    createBundleDrop(){
        // find all the bundles on this page and get their IDs 
        const the_bundle_prods = document.getElementsByClassName('CollectionVueSelectWrap--mobile');
        let the_el_ids = Array.prototype.map.call(the_bundle_prods, function(el){
        return el.id
        })
    
        console.log(the_el_ids)
        // init vue instance for each 
        the_el_ids.forEach(function(element, index){
        // let the_var_name = 'selectVue_'+index
        
        the_vues[index] = new Vue({
            el: '#'+element,
            delimiters: ['${', '}'],
            store,
            data: function() {
            return {
                handle: 'og handle',
                index: index,
                title: 'Test Title',
                productData: {},
                is_diff_size: true,
                qty_to_add: 1,
                added: false,
                same_sizes: [],
                diff_sizes: [],
                diff_types: [],
                the_sizes: [],
                grouped_variants:[],
                ungrouped_variants: [],
                selected_size: '',
                selected_sizes: [],
                addToCartText: 'Select A Size',
                tozps_group: [ 'lounge tops', 'swim top', 'merch tops' ],
                tops: [],
                bottoms_group: ['active bottoms', 'bikini', 'brief', 'lounge bottoms', 'swim bottoms', 'thong', 'boyshort'],
                bottoms: [],
                bras_group: ['demi-pad', 'maternity bras', 'no-wire', 'pushup', 'strapless', 't-shirt', 'unlined'],
                bras: [],
                bralettes_group: [ 'active bras', 'bralette', 'maternity'   ],
                bralettes: [],
                misc_group: ['Cool Things', 'bodysuit', 'candle', 'fragrance', 'kits', 'lounge wrap', 'roller', 'swim one pieces', 'maternity bodysuit'],
                misc: [],
                loadComplete: false
            }
            },
            created: function(){},
            mounted: function(){
            // set the handle to the legit handle 
            this.handle = this.$refs.CollectionVueSelectWrap.dataset.handle;
            this.getData();
            
            },
            methods:{
            getData: function(){
                let theHandle = this.handle;
                let vm = this;
                let the_url = window.Shopify.routes.root + 'products/'+theHandle+'?view=bundlejson'
                axios.get(the_url)
                .then(function (response) {
                    console.log('build getData')
                    // console.log(response);
                    vm.productData = response.data
                    vm.is_diff_size = response.data.different_sizes
                    vm.qty_to_add = parseInt(response.data.single_prod_qty)
                    vm.getSizes();
                    vm.buildSizes();
                    // vm.outsideListener();
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            getSizes: function(){
                this.ungrouped_variants = []
                let vm = this;
                if(this.is_diff_size === false){
                let size_range = this.productData.bundle_same[0].variants.map(function(variant){
                    // console.log(variant.option1);
                    return variant.option1
                })
                this.same_sizes = size_range

                // push all variants to ungrouped 
                this.productData.bundle_same.forEach(function(product){
                    product.variants.forEach(function(variant){
                    vm.ungrouped_variants.push(variant)
                    })
                });
                }else{

                }
            },
            buildSizes: function(){
                console.log('build sizes')
                let vm = this;
                const products_count = this.productData.bundle_same.length;
                if(this.is_diff_size == false){
                const the_sizes = this.same_sizes
                const same_prod_qty = this.qty_to_add
                let the_size_arr = the_sizes.map(function(size){
                    let the_current_size = size;
                    // console.log('size for eacn')
                    // console.log(size)
                    let the_matching_variants = vm.ungrouped_variants.filter(function(variant){
                    // if opt1 = current size, add releveant info as an obj to the array
                    if (variant.option1 === the_current_size ){
                        return variant
                    }else{
                        return false
                    }
                    }).map(function(variant){
                    // console.log('map');
                    return { "id": variant.id, "qty": variant.qty, "sku": variant.sku }
                    });
                        
                    let is_sold_out = the_matching_variants.every(function (number){
                    return number.qty > same_prod_qty;
                    });
                    let variants_count = (products_count === the_matching_variants.length)?true:false;
                    // console.log('VARIANTS COUNT')
                    // console.log(variants_count)
                    console.log("FIND THE RIGHT NUMBER OF THINGS")
                    console.log(vm.handle)
                    //handle non uniform sizing
                    let productCount = vm.productData.bundle_same.length
                    let occurencesOfSize = vm.ungrouped_variants.reduce((count, variant) => count + (variant.option1 === size), 0)
                    let the_conditions_array = [!is_sold_out, variants_count]
                    let the_conditions = the_conditions_array.every(Boolean) || (productCount !== occurencesOfSize)
                    
                    // console.log('the_matching_variants');
                    // console.log(the_matching_variants)
                    return {"size": size, "soldout": the_conditions, "variants": the_matching_variants}
                });

                // console.log('the_size_arr');
                // console.log(the_size_arr);

                // console.log('set group variants');
                this.grouped_variants = the_size_arr;
                }else{
                // console.log('build diff Sizes');
                let the_size_arr = this.diff_sizes.map(function(size){
                    // current grouping type
                    let the_current_type = size.type;
                    let the_group_type = the_current_type+"_group"
                    // console.log('the product type we dealing with: ');
                    // console.log(the_current_type)
                
                    // loop over the current sizes, find the matching size in our grouped array,
                    // console.log('start to map group sizes');
                    let the_grouped_sizes = size.sizes.map(function(sz){
                    let the_current_size = sz
                    // console.log('current size: '+sz);
                    // filter ALL variants, grab the variants where the curernt type matches the group & the current size is the current size
                    let grouped_vars = vm.ungrouped_variants.filter(function(variant){
                        // console.log('filter')
                        // console.log(variant)
                        // console.log(variant.option1)
                        // console.log(variant.type)
                        if (variant.option1 === the_current_size && vm[the_group_type].includes(variant.type) ){
                            return variant
                        }else{
                            false
                        }
                    }).map(function(variant){
                        console.log('map');
                        return { "id": variant.id, "qty": variant.qty, "sku": variant.sku } 
                    });
                        
                    let is_sold_out = grouped_vars.every(function (number){
                        return number.qty > 1;
                    });
                    

                    return {"size": the_current_size, "soldout": !is_sold_out,  "the_variants": grouped_vars }

                    }); //end grouped_sizes
                    // return the current type + the grouped sizes 
                    // Select Your ___ Size
                    let the_label = ''
                    if(the_current_type==='bras'){
                    the_label = 'Select Your Bra Size'
                    }
                    if(the_current_type==='bralettes'){
                    the_label = 'Select Your Bralette Size'
                    }
                    if(the_current_type==='tops'){
                    the_label = 'Select Your Top Size'
                    }
                    if(the_current_type==='bottoms'){
                    the_label = 'Select Your Bottom Size'
                    }
                    if(the_current_type==='misc'){
                    the_label = 'Select A Size'
                    }
                    return { "type": the_current_type, "label":the_label, "sizes": the_grouped_sizes }
                }); //end the_size_arr
                this.grouped_variants = the_size_arr;
                }
                this.loadComplete = true;
            },
            selectingSize: function(){
                this.addToCartText = 'Adding'
                this.added = true;
                const the_qty = this.qty_to_add;
                // whichever size is currently selected, find the IDs and add it to cart
                // check the current selected size
                let selected_bundle_size = this.selected_size
                let all_varaints = this.grouped_variants
                let vm = this;
                let the_ids =[]
                let just_ids = []
                let dupe_id_qty = {};

                // Filter through the current sizes, grab their IDs 
                all_varaints.filter(function(size){
                // console.log('current size: '+ size.size)
                    if (size.size === selected_bundle_size){
                    // console.log('matching')
                    just_ids = size.variants.map(function(variant){
                        // console.log('variant.id')
                        // console.log(variant.id)
                        // return variant.id
                        return variant.id
                    })
                    return just_ids
                    }
                });

                console.log('just_ids')
                console.log(just_ids)
                // Grab the num of times we have each variant ID 
                for (const num of just_ids) {
                dupe_id_qty[num] = dupe_id_qty[num] ? dupe_id_qty[num] + 1 : 1;
                }
                console.log('dupe_id_qty');
                console.log(dupe_id_qty)

                the_ids = just_ids.map(function(variant){
                let the_final_qty = the_qty * dupe_id_qty[variant]
                return {id: variant, quantity:the_final_qty, properties: { "_bundle": true, "_bundleTitle": vm.productData.current_title } }
                })

        
                console.log('the final IDs')
                console.log(the_ids)

                if (this.productData.add_os_item){
                // grab the one sized item, jam it into the IDs rigth away 
                this.productData.one_size.forEach(function(product){
                    // console.log(product.variants[0].id)
                    // the_ids.push(product.variants[0].id) 
                    the_ids.push({id: product.variants[0].id, quantity:the_qty, properties: { "_bundle": true, "_bundleTitle": vm.productData.current_title } })
                });
                // the_ids.push()
                }

                let final_unique_ids = []
                final_unique_ids =  the_ids.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
                console.log('final_ids');
                console.log(final_unique_ids);

                // Add to cart via cart API
                let the_url = window.Shopify.routes.root + 'cart/add.js';
                let cartPromise = $.post(the_url, {
                items: final_unique_ids
                })
                .done(function() {
                console.log( "second success" );
                vm.addToCartText = 'Added!'
                vm.added = true;
                // Trigger an update 
                store.dispatch('cart/updateCart');

                let theEventName = 'Quick Add - Added Product'
                let quickAddType = 'default'
                if(typeof vm.$refs.CollectionVueSelectWrap.dataset.eventname !== 'undefined'){

                    console.log('has an event')
                    
                    theEventName = 'Quick Add - ' + vm.$refs.CollectionVueSelectWrap.dataset.eventname
                    quickAddType = vm.$refs.CollectionVueSelectWrap.dataset.eventname
                    console.log(theEventName)
                    // theEventName = the_select_menu.data('eventname');
                }else{
                    console.log('does not have an event')
                    console.log(theEventName)
                }
            
                
                // Trigger all pixel events
              

                let eventType = vm.$refs.CollectionVueSelectWrap.dataset.eventname
                console.log("EVENT TYPE BUNDLE DROP")
                console.log(eventType)

                //GA4
                vm.productData.bundle_same.forEach(item => {
                    let title = item.title.slice(0, item.title.indexOf(':'))
                    let color = item.title.slice(item.title.indexOf(':') + 2)
                    gtag('event', 'added_prod', {
                        'product': title,
                        'variant': vm.selected_size,
                        'color' : color,
                        'type': eventType,
                        'Bundle': true
                    })
                })

                
                if (rdt) {
                    console.log('Reddit add to cart - QuickAdd');
                    rdt('track', 'AddToCart');
                }
                
                // change the add to cart button text back 
                setTimeout(function(){
                    vm.added = false;
                    vm.selected_size = '';
                }, 1200);
                })
                .fail(function() {
                console.log( "error" );
                })
                .always(function() {
                console.log( "finished" );
                });       
            },
            outsideListener: function(){
                // let the_new_handle = ''
                let vm = this;
                $('.js-SwatchItemBundle').on('click', function(){
                    let clicked_handle = $(this).attr('data-handle');
                    vm.resetData();
                    vm.handle = clicked_handle
                    vm.getData();
                });
            },
            resetData(newhandle) {
                Object.keys(dataDefault).forEach(k => {
                if (Object.prototype.hasOwnProperty.call(this.$data, k)) {
                    this.$data[k] = dataDefault[k];
                }
                });

                this.handle = newhandle;
                this.getData();
            }
            }
        })
        })
    },
    createBundleDropDesktop(the_element){

        let index = the_vues.length + 1
        
        the_vues[index] = new Vue({
            el: "#"+the_element,
            delimiters: ['${', '}'],
            data: function() {
            return {
                handle: 'og handle',
                index: index,
                title: 'Test Title',
                productData: {},
                is_diff_size: true,
                qty_to_add: 1,
                added: false,
                same_sizes: [],
                diff_sizes: [],
                diff_types: [],
                the_sizes: [],
                grouped_variants:[],
                ungrouped_variants: [],
                selected_size: '',
                selected_sizes: [],
                addToCartText: 'Select A Size',
                tops_group: [ 'lounge tops', 'swim top', 'merch tops' ],
                tops: [],
                bottoms_group: ['active bottoms', 'bikini', 'brief', 'lounge bottoms', 'swim bottoms', 'thong', 'boyshort'],
                bottoms: [],
                bras_group: ['demi-pad', 'maternity bras', 'no-wire', 'pushup', 'strapless', 't-shirt', 'unlined'],
                bras: [],
                bralettes_group: [ 'active bras', 'bralette', 'maternity'   ],
                bralettes: [],
                misc_group: ['Cool Things', 'bodysuit', 'candle', 'fragrance', 'kits', 'lounge wrap', 'roller', 'swim one pieces', 'maternity bodysuit'],
                misc: [],
                loadComplete: false
            }
            },
            created: function(){},
            mounted: function(){
            // set the handle to the legit handle 
            this.handle = this.$refs.CollectionVueSelectWrap.dataset.handle;
            this.getData();
            let vm = this;
            // event listener for this 
            // $('.js-SwatchItemBundle').on('click', function(){
            //   console.log('vue click')
            //   // let clicked_handle = $(this).attr('data-handle');
            //   // vm.resetData(clicked_handle);
            //   // vm.handle = clicked_handle
            //   // vm.getData();
                
            // });
            
            },
            methods:{
            getData: function(){
                let theHandle = this.handle;
                let vm = this;
                let the_url = window.Shopify.routes.root + 'products/'+theHandle+'?view=bundlejson'
                axios.get(the_url)
                .then(function (response) {
                    console.log('build getData')
                    // console.log(response);
                    vm.productData = response.data
                    vm.is_diff_size = response.data.different_sizes
                    vm.qty_to_add = parseInt(response.data.single_prod_qty)
                    vm.getSizes();
                    vm.buildSizes();
                    // vm.outsideListener();
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            getSizes: function(){
                this.ungrouped_variants = []
                let vm = this;
                if(this.is_diff_size === false){
                let size_range = this.productData.bundle_same[0].variants.map(function(variant){
                    // console.log(variant.option1);
                    return variant.option1
                })
                this.same_sizes = size_range

                // push all variants to ungrouped 
                this.productData.bundle_same.forEach(function(product){
                    product.variants.forEach(function(variant){
                    vm.ungrouped_variants.push(variant)
                    })
                });
                }else{

                }
            },
            buildSizes: function(){
                console.log('build sizes')
                let vm = this;
                const products_count = this.productData.bundle_same.length;
                const same_prod_qty = this.qty_to_add
                if(this.is_diff_size == false){
                const the_sizes = this.same_sizes
                
                let the_size_arr = the_sizes.map(function(size){
                    let the_current_size = size;
                    // console.log('size for eacn')
                    // console.log(size)
                    let the_matching_variants = vm.ungrouped_variants.filter(function(variant){
                    // if opt1 = current size, add releveant info as an obj to the array
                    if (variant.option1 === the_current_size ){
                        return variant
                    }else{
                        return false
                    }
                    }).map(function(variant){
                    // console.log('map');
                    return { "id": variant.id, "qty": variant.qty, "sku": variant.sku }
                    });
                        
                    let is_sold_out = the_matching_variants.every(function (number){
                    return number.qty > same_prod_qty;
                    });
                    let variants_count = (products_count === the_matching_variants.length)?true:false;
                    // console.log('VARIANTS COUNT')
                    // console.log(variants_count)
                    // console.log('instock: '+is_sold_out);
                    //handle non uniform sizing
                    let productCount = vm.productData.bundle_same.length
                    let occurencesOfSize = vm.ungrouped_variants.reduce((count, variant) => count + (variant.option1 === size), 0)
                    let the_conditions_array = [!is_sold_out, variants_count]
                    let the_conditions = the_conditions_array.every(Boolean) || (productCount !== occurencesOfSize)
                    // console.log('the_matching_variants');
                    // console.log(the_matching_variants)
                    return {"size": size, "soldout": the_conditions, "variants": the_matching_variants}
                });

                // console.log('the_size_arr');
                // console.log(the_size_arr);

                // console.log('set group variants');
                this.grouped_variants = the_size_arr;
                }else{
                // console.log('build diff Sizes');
                let the_size_arr = this.diff_sizes.map(function(size){
                    // current grouping type
                    let the_current_type = size.type;
                    let the_group_type = the_current_type+"_group"
                    // console.log('the product type we dealing with: ');
                    // console.log(the_current_type)
                
                    // loop over the current sizes, find the matching size in our grouped array,
                    // console.log('start to map group sizes');
                    let the_grouped_sizes = size.sizes.map(function(sz){
                    let the_current_size = sz
                    // console.log('current size: '+sz);
                    // filter ALL variants, grab the variants where the curernt type matches the group & the current size is the current size
                    let grouped_vars = vm.ungrouped_variants.filter(function(variant){
                        // console.log('filter')
                        // console.log(variant)
                        // console.log(variant.option1)
                        // console.log(variant.type)
                        if (variant.option1 === the_current_size && vm[the_group_type].includes(variant.type) ){
                            return variant
                        }else{
                            false
                        }
                    }).map(function(variant){
                        console.log('map');
                        return { "id": variant.id, "qty": variant.qty, "sku": variant.sku } 
                    });
                        
                    let is_sold_out = grouped_vars.every(function (number){
                        return number.qty > 1;
                    });
                    

                    return {"size": the_current_size, "soldout": !is_sold_out,  "the_variants": grouped_vars }

                    }); //end grouped_sizes
                    // return the current type + the grouped sizes 
                    // Select Your ___ Size
                    let the_label = ''
                    if(the_current_type==='bras'){
                    the_label = 'Select Your Bra Size'
                    }
                    if(the_current_type==='bralettes'){
                    the_label = 'Select Your Bralette Size'
                    }
                    if(the_current_type==='tops'){
                    the_label = 'Select Your Top Size'
                    }
                    if(the_current_type==='bottoms'){
                    the_label = 'Select Your Bottom Size'
                    }
                    if(the_current_type==='misc'){
                    the_label = 'Select A Size'
                    }
                    return { "type": the_current_type, "label":the_label, "sizes": the_grouped_sizes }
                }); //end the_size_arr
                this.grouped_variants = the_size_arr;
                }
                this.loadComplete = true;
            },
            selectingSize: function(){
                // whichever size is currently selected, find the IDs and add it to cart
                // check the current selected size
                let selected_bundle_size = this.selected_size
                let all_varaints = this.grouped_variants
                let vm = this;
                let the_ids =[]
                const the_qty = this.qty_to_add;
                let just_ids = []
                let dupe_id_qty = {};

                // Filter through the current sizes, grab their IDs 
                all_varaints.filter(function(size){
                // console.log('current size: '+ size.size)
                    if (size.size === selected_bundle_size){
                    // console.log('matching')
                    just_ids = size.variants.map(function(variant){
                        // console.log('variant.id')
                        // console.log(variant.id)
                        // return variant.id
                        return variant.id
                    })
                    return just_ids
                    }
                });

                console.log('just_ids')
                console.log(just_ids)
                // Grab the num of times we have each variant ID 
                for (const num of just_ids) {
                dupe_id_qty[num] = dupe_id_qty[num] ? dupe_id_qty[num] + 1 : 1;
                }
                console.log('dupe_id_qty');
                console.log(dupe_id_qty)

                the_ids = just_ids.map(function(variant){
                let the_final_qty = the_qty * dupe_id_qty[variant]
                return {id: variant, quantity:the_final_qty, properties: { "_bundle": true, "_bundleTitle": vm.productData.current_title } }
                })

        
                console.log('the final IDs')
                console.log(the_ids)
                if (this.productData.add_os_item){
                // grab the one sized item, jam it into the IDs rigth away 
                this.productData.one_size.forEach(function(product){
                    // console.log(product.variants[0].id)
                    // the_ids.push(product.variants[0].id) 
                    the_ids.push({id: product.variants[0].id, quantity:the_qty, properties: { "_bundle": true, "_bundleTitle": vm.productData.current_title } }) 
                });
                // the_ids.push()
                }
                let final_unique_ids = []
                final_unique_ids =  the_ids.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
                console.log('final_ids');
                console.log(final_unique_ids);


                // Add to cart via cart API
                let the_url = window.Shopify.routes.root + 'cart/add.js';
                let cartPromise = $.post(the_url, {
                items: final_unique_ids
                })
                .done(function() {
                console.log( "second success" );
                vm.addToCartText = 'Added!'
                vm.added = true;
                // Trigger an update 
                store.dispatch('cart/updateCart');

                let theEventName = 'Quick Add - Added Product'
                let quickAddType = 'default'  
                if(typeof vm.$refs.CollectionVueSelectWrap.dataset.eventname !== 'undefined'){
                    console.log('has an event')
                    
                    theEventName = 'Quick Add - ' + vm.$refs.CollectionVueSelectWrap.dataset.eventname
                    quickAddType = vm.$refs.CollectionVueSelectWrap.dataset.eventname;
                    console.log(theEventName)
                    // theEventName = the_select_menu.data('eventname');
                }else{
                    console.log('does not have an event')
                    console.log(theEventName)
                }
                
                // Trigger all pixel events
                let eventType = vm.$refs.CollectionVueSelectWrap.dataset.eventname

                //GA4
                vm.productData.bundle_same.forEach(item => {
                    let title = item.title.slice(0, item.title.indexOf(':'))
                    let color = item.title.slice(item.title.indexOf(':') + 2)
                    gtag('event', 'added_prod', {
                        'product': title,
                        'variant': vm.selected_size,
                        'color' : color,
                        'type': eventType,
                        'Bundle': true
                    })
                })

                
                if (rdt) {
                    console.log('Reddit add to cart - QuickAdd');
                    rdt('track', 'AddToCart');
                }

                // change the add to cart button text back 
                setTimeout(function(){
                    vm.added = false;
                    vm.selected_size = '';
                }, 1000);
                })
                .fail(function() {
                console.log( "error" );
                })
                .always(function() {
                console.log( "finished" );
                });

            },
            outsideListener: function(){
                // let the_new_handle = ''
                let vm = this;
                $('.js-SwatchItemBundle').on('click', function(){
                let clicked_handle = $(this).attr('data-handle');
                vm.resetData();
                vm.handle = clicked_handle
                vm.getData();
                
                });
            },
            resetData(newhandle) {
                Object.keys(dataDefault).forEach(k => {
                if (Object.prototype.hasOwnProperty.call(this.$data, k)) {
                    this.$data[k] = dataDefault[k];
                }
                });

                this.handle = newhandle;
                this.getData();
            }
            }
        })

    },
    swatches() {
        $('.js-SwatchItem').on('click', function() {
        let $this = $(this);
        let the_handle = $(this).attr('data-handle');
        let root_url = window.Shopify.routes.root;
        let the_new_url = root_url + 'products/' + the_handle;
        // let the_new_img =  $(this).attr('data-img-src');
        let the_img_tag = $(this)
            .closest('.ProductGridItemNew')
            .find('.ProductGridItemNew-image');
        let the_img_link = $(this)
            .closest('.ProductGridItemNew')
            .find('.ProductGridItemNew-imagelink');
        let the_title_link = $(this)
            .closest('.ProductGridItemNew')
            .find('.ProductGridItemNew-title');
        let mobile_quick_btn = $(this)
            .closest('.ProductGridItemNew')
            .find('.js-ProductGridItemNew-quick');
        let the_select = $(this)
            .closest('.ProductGridItemNew')
            .find('.ProductGridItemNew-select');
        let the_select_visible = $(this)
            .closest('.ProductGridItemNew')
            .find('.ProductGridItemNew-select:visible');
        let the_desk_select = $(this)
            .closest('.ProductGridItemNew')
            .find('.ProductGridItemNew-selectDesk');
        let the_desk_quick = $(this)
            .closest('.ProductGridItemNew')
            .find('.js-ProductGridQuickView');
        let the_item = $(this).closest('.ProductGridItemNew');
        let is_bundle = false;
        let is_kit = false;
        let current_index_mobile, current_index_desktop;
        
        // the_img_tag.attr('srcset', the_new_img);
        if ( the_select.attr('data-bundle') === 'true' ){
            is_bundle = true;
            // CollectionVueSelectWrap
            current_index_mobile = $(this).closest('.ProductGridItemNew').find('.CollectionVueSelectWrap--mobile > div:first-child').text();
            current_index_mobile = parseInt(current_index_mobile);
            current_index_desktop = $(this).closest('.ProductGridItemNew').find('.CollectionVueSelectWrap-desk > div:first-child').text();
            the_vues[current_index_mobile].resetData(the_handle);
            if( the_vues[current_index_desktop] !== undefined ){
            the_vues[current_index_desktop].resetData(the_handle);
            }
        }

        if ( the_item.attr('data-is-kit') === 'true' ){
            is_kit = true;
            // console.log('the endpoint: '+ the_endpoint)
            let the_url = window.Shopify.routes.root + 'products/'+the_handle+'?view=kitjson';
            axios.get(the_url)
            .then(function (response) {
                console.log(response);
                let data = response.data
                console.log('swatched: ' + data.title);
                the_img_tag.attr('srcset', data.images[0]);
    
                the_img_tag.attr('data-src', data.images[0]);
                the_img_tag.attr('alt', data.title);
                the_img_tag.attr('data-srcset', data.images[0]);
    
                // Update the links
                the_img_link.attr('href', the_new_url);
                the_title_link.attr('href', the_new_url);
    
                // Update the handles
                console.log('data handle: ' + data.handle);
                mobile_quick_btn.attr('data-handle', data.handle);
                the_desk_quick.attr('data-handle', data.handle);
                the_item.attr('data-handle', data.handle);
                // if it's not a bundle
            if(!is_bundle){
                // remove the options from the current select menu, change them to be the
                console.log('empty the select menu ');
                the_select.empty();
                the_desk_select.empty();
                the_select.append(
                '<option class="ProductGridItemNew-option ProductGridItemNew-option-label" value="label" selected="" role="label" id="option-label">Choose Your Size</option>'
                );
                the_desk_select.append(
                '<option class="ProductGridItemNew-option ProductGridItemNew-option-label" value="label" selected="" role="label" id="option-label">ADD NOW</option>'
                );
                // setTimeout( function(){
                console.log('getting variants');
                // Get all the variants
                $.each(data.variants, function(key, value) {
                let variant = value;
                let theVariantID = variant.id;
                let theVariantTitle = variant.title;
                let is_default = false;
                let theVariantSku = variant.sku;
                console.log(theVariantSku);
                let theVariantPrice = variant.price / 100;
                theVariantPrice = theVariantPrice.toFixed(2);

                let inStock = variant.available;
                // let continueSelling = variant.inventory_policy;
                let theVariantQuantity = parseInt(variant.inventory_quantity, 10);
                if (theVariantTitle.includes('/')) {
                    theVariantTitle = theVariantTitle.substr(0, theVariantTitle.indexOf(' /'));
                } else {
                    console.log('variant title: ' + theVariantTitle);
                    is_default = true;
                }
                // if the variant is in stock,
                if (inStock) {
                    if (theVariantQuantity <= 0 && variant.inventory_management != null) {
                    the_select.append(
                        '<option role="option" class="ProductGridItemNew-option"  data-title="' +
                        theVariantTitle +
                        '" data-preorder="preorder" value="' +
                        theVariantID +
                        '" data-sku="' +
                        theVariantSku +
                        '" data-price="' +
                        theVariantPrice +
                        '">' +
                        theVariantTitle +
                        ' (PREORDER)</option>'
                    );
                    } else {
                    // If there's one title, select this, and append it. Call it "one size" or something instead fo the variant ID
                    if (is_default) {
                        the_select.append(
                        '<option role="option" data-title="' +
                            theVariantTitle +
                            '"  data-quantity="' +
                            theVariantQuantity +
                            '" value="' +
                            theVariantID +
                            '" data-sku="' +
                            theVariantSku +
                            '" data-price="' +
                            theVariantPrice +
                            '">One Size</option>'
                        );
                    } else {
                        the_select.append(
                        '<option role="option" data-title="' +
                            theVariantTitle +
                            '"  data-quantity="' +
                            theVariantQuantity +
                            '" value="' +
                            theVariantID +
                            '" data-sku="' +
                            theVariantSku +
                            '" data-price="' +
                            theVariantPrice +
                            '">' +
                            theVariantTitle +
                            '</option>'
                        );
                    }
                    }
                } else {
                    the_select.append(
                    '<option disabled data-title="' +
                        theVariantTitle +
                        '" value="' +
                        theVariantID +
                        '" data-sku="' +
                        theVariantSku +
                        '">' +
                        theVariantTitle +
                        ' - SOLD OUT</option>'
                    );
                }
                });

            }
            if (the_select_visible.length == 0 && $(window).width() < 1024) {
                TweenMax.to(the_select, 0.1, { autoAlpha: 1, display: 'block', ease: Power2.ease });
                TweenMax.to(mobile_quick_btn, 0.1, { autoAlpha: 0, display: 'none', ease: Power2.ease });
            }
            // Select the right swatch
            console.log('add this class');
            $this.addClass('swatchItem--is-active');
            $this.siblings('.swatchItem--is-active').removeClass('swatchItem--is-active');

            the_item.find('.ProductGridItemNew-kitItems').text(data.the_kit_items)
        
                
            })
            .catch(function (error) {
                console.log(error);
                
            });
        }else{

            let the_url = window.Shopify.routes.root + 'products/' + the_handle + '.js'
            let promise = $.getJSON(the_url);
            promise.done(function(data) {
            console.log('swatched: ' + data.title);
            the_img_tag.attr('srcset', data.images[0]);

            the_img_tag.attr('data-src', data.images[0]);
            the_img_tag.attr('alt', data.title);
            the_img_tag.attr('data-srcset', data.images[0]);

            // Update the links
            the_img_link.attr('href', the_new_url);
            the_title_link.attr('href', the_new_url);

            // Update the handles
            console.log('data handle: ' + data.handle);
            mobile_quick_btn.attr('data-handle', data.handle);
            the_desk_quick.attr('data-handle', data.handle);
            the_item.attr('data-handle', data.handle);

            const price = the_item.find('.ProductGridItemNew-price')
            const compareAtPrice = the_item.find('.ProductGridItemNew-comparePrice').find('s')
            // const pricelineFlag = the_item.find('.ProductCard-flag')
            // const overlayBannerWrap = the_item.find('.ProductCard-image-banner-wrap')

            //price 
            let newPrice = (data.price / 100).toLocaleString("en-US", {style:"currency", currency:"USD"})
            if(newPrice.split('.').pop() === '00'){
                newPrice = newPrice.split('.')[0]
            }
            price.text(newPrice)
            console.log(data)
            console.log(data.price)
            console.log(data.compare_at_price)
            //compare at price
            if(data.compare_at_price != null && data.price < data.compare_at_price){
                console.log('compare at activated')
                let newCompareAtPrice = (data.compare_at_price / 100).toLocaleString("en-US", {style:"currency", currency:"USD"})
                if(newCompareAtPrice.split('.').pop() === '00'){
                newCompareAtPrice = newCompareAtPrice.split('.')[0]
                }
                console.log(compareAtPrice)
                compareAtPrice.text(newCompareAtPrice)
                console.log(newCompareAtPrice)
                
            } else {
                compareAtPrice.text('')
            }

            
            // if it's not a bundle
            if(!is_bundle){
                // remove the options from the current select menu, change them to be the
                console.log('empty the select menu ');
                the_select.empty();
                the_desk_select.empty();
                the_select.append(
                '<option class="ProductGridItemNew-option ProductGridItemNew-option-label" value="label" selected="" role="label" id="option-label">Choose Your Size</option>'
                );
                the_desk_select.append(
                '<option class="ProductGridItemNew-option ProductGridItemNew-option-label" value="label" selected="" role="label" id="option-label">ADD NOW</option>'
                );
                // setTimeout( function(){
                console.log('getting variants');
                // Get all the variants
                $.each(data.variants, function(key, value) {
                let variant = value;
                let theVariantID = variant.id;
                let theVariantTitle = variant.title;
                let is_default = false;
                let theVariantSku = variant.sku;
                console.log(theVariantSku);
                let theVariantPrice = variant.price / 100;
                theVariantPrice = theVariantPrice.toFixed(2);

                let inStock = variant.available;
                // let continueSelling = variant.inventory_policy;
                let theVariantQuantity = parseInt(variant.inventory_quantity, 10);
                if (theVariantTitle.includes('/')) {
                    theVariantTitle = theVariantTitle.substr(0, theVariantTitle.indexOf(' /'));
                } else {
                    console.log('variant title: ' + theVariantTitle);
                    is_default = true;
                }
                // if the variant is in stock,
                if (inStock) {
                    if (theVariantQuantity <= 0 && variant.inventory_management != null) {
                    the_select.append(
                        '<option role="option" class="ProductGridItemNew-option"  data-title="' +
                        theVariantTitle +
                        '" data-preorder="preorder" value="' +
                        theVariantID +
                        '" data-sku="' +
                        theVariantSku +
                        '" data-price="' +
                        theVariantPrice +
                        '">' +
                        theVariantTitle +
                        ' (PREORDER)</option>'
                    );
                    } else {
                    // If there's one title, select this, and append it. Call it "one size" or something instead fo the variant ID
                    if (is_default) {
                        the_select.append(
                        '<option role="option" data-title="' +
                            theVariantTitle +
                            '"  data-quantity="' +
                            theVariantQuantity +
                            '" value="' +
                            theVariantID +
                            '" data-sku="' +
                            theVariantSku +
                            '" data-price="' +
                            theVariantPrice +
                            '">One Size</option>'
                        );
                    } else {
                        the_select.append(
                        '<option role="option" data-title="' +
                            theVariantTitle +
                            '"  data-quantity="' +
                            theVariantQuantity +
                            '" value="' +
                            theVariantID +
                            '" data-sku="' +
                            theVariantSku +
                            '" data-price="' +
                            theVariantPrice +
                            '">' +
                            theVariantTitle +
                            '</option>'
                        );
                    }
                    }
                } else {
                    the_select.append(
                    '<option disabled data-title="' +
                        theVariantTitle +
                        '" value="' +
                        theVariantID +
                        '" data-sku="' +
                        theVariantSku +
                        '">' +
                        theVariantTitle +
                        ' - SOLD OUT</option>'
                    );
                }
                });

            }
        
                

            // }, 75 );
            if (the_select_visible.length == 0 && $(window).width() < 1024) {
                TweenMax.to(the_select, 0.1, { autoAlpha: 1, display: 'block', ease: Power2.ease });
                TweenMax.to(mobile_quick_btn, 0.1, { autoAlpha: 0, display: 'none', ease: Power2.ease });
            }
            // Select the right swatch
            console.log('add this class');
            $this.addClass('swatchItem--is-active');
            $this.siblings('.swatchItem--is-active').removeClass('swatchItem--is-active');
            });

            promise.fail(function(textStatus, error) {
            let err = textStatus + ', ' + error;
            console.log(textStatus + ' Request Failed: ' + err);
            });
        }

        });

        $('.swatchItemMore').click(function() {
        //  let hidden_swatches =  $(this).closest('.ProductGridItemNew-swatch').find('.swatchItem--hidden');
        $(this)
            .closest('.ProductGridItemNew-swatch')
            .addClass('wrap');
        TweenMax.to($(this).siblings(), 0.1, { autoAlpha: 1, display: 'flex', ease: Power2.ease });
        TweenMax.to($(this), 0.1, { autoAlpha: 0, display: 'none', ease: Power2.ease });
        //  TweenMax.to( $(this).siblings(), 0.1, { autoAlpha: 0, display:'none', ease: Power2.ease } );
        TweenMax.to($(this).siblings('.swatchItemLess'), 0.1, {
            autoAlpha: 1,
            display: 'flex',
            ease: Power2.ease
        });
        });
        $('.swatchItemLess').click(function() {
        // let hidden_swatches =  $(this).closest('.ProductGridItemNew-swatch').find('.swatchItem--hidden');
        TweenMax.to($(this), 0.1, { autoAlpha: 0, display: 'none', ease: Power2.ease });
        TweenMax.to($(this).siblings('.swatchItem--hidden'), 0.1, {
            autoAlpha: 0,
            display: 'none',
            ease: Power2.ease
        });
        TweenMax.to($(this).siblings('.swatchItemMore'), 0.1, {
            autoAlpha: 1,
            display: 'flex',
            ease: Power2.ease
        });
        });
    },
    desktopQuick() {
        // Show Options
        $('.js-ProductGridItemNew-imageWrap').hover(
          function() {
            $(this)
              .find('.ProductGridItemNew-quickWrap')
              .removeClass('is-open');
            $(this)
              .find('.ProductGridItemNew-actionsDesktop')
              .removeClass('is-add-open');
            if ($(this).find('.ProductGridItemNew-banner')) {
              TweenMax.to($(this).find('.ProductGridItemNew-banner'), 0.1, {
                autoAlpha: 0,
                display: 'none',
                ease: Power2.ease
              });
            }
            TweenMax.to($(this).find('.QuickAddDesk'), 0.1, {
              autoAlpha: 0,
              display: 'none',
              ease: Power2.ease
            });
            TweenMax.to($(this).find('.ProductGridItemNew-actionsDesktop'), 0.1, {
              autoAlpha: 1,
              display: 'flex',
              ease: Power2.ease
            });
            TweenMax.to($(this).find('.ProductGridItemNew-selectDesk'), 0.1, {
              autoAlpha: 1,
              display: 'flex',
              ease: Power2.ease
            });
            TweenMax.to($(this).find('.js-ProductGridQuickView'), 0.1, {
              autoAlpha: 1,
              display: 'block',
              ease: Power2.ease
            });
    
            let the_id = $(this).find('.CollectionVueSelectWrap-desk').attr('id');
            
            if($(this).find('.js-ProductGridItemNew-selectDesk > option').length === 2){
              console.log('the id: '+the_id)
              quickAdd.createBundleDropDesktop(the_id);
            }
            
    
            // // //
            // if( $(this).find('.js-ProductGridItemNew-selectDesk:visible').length == 0  ){
            //   TweenMax.to( $(this).find('.js-ProductGridItemNew-selectDesk'), 0.1, { autoAlpha: 1, display:'block', ease: Power2.ease } );
            //   TweenMax.to( $(this).find('.js-ProductGridItemNew-quick'), 0.1, { autoAlpha: 0, display:'none', ease: Power2.ease } );
            // }
          },
          function() {
            if ($(this).find('.ProductGridItemNew-banner')) {
              TweenMax.to($(this).find('.ProductGridItemNew-banner'), 0.1, {
                autoAlpha: 1,
                display: 'block',
                ease: Power2.ease
              });
            }
            TweenMax.to($(this).find('.QuickAddDesk'), 0.1, {
              autoAlpha: 0,
              display: 'none',
              ease: Power2.ease
            });
            TweenMax.to($(this).find('.ProductGridItemNew-actionsDesktop'), 0.1, {
              autoAlpha: 0,
              display: 'none',
              ease: Power2.ease
            });
            TweenMax.to($(this).find('.ProductGridItemNew-selectDesk'), 0.1, {
              autoAlpha: 0,
              display: 'none',
              ease: Power2.ease
            });
            TweenMax.to($(this).find('.js-ProductGridQuickView'), 0.1, {
              autoAlpha: 0,
              display: 'none',
              ease: Power2.ease
            });
            // TweenMax.to( $(this).find('.QuickAddDesk'), 0.1, { autoAlpha: 0, display:'none', ease: Power2.ease } );
          }
        );
    
        // Quick Add
        $('.js-ProductGridItemNew-selectDesk').on('click, mousedown', function() {
          console.log('click change');
          // Full width, hide quickshop
          $(this)
            .closest('.ProductGridItemNew-quickWrap')
            .addClass('is-open');
          $(this)
            .closest('.ProductGridItemNew-actionsDesktop')
            .addClass('is-add-open');
          let the_quickshop_btn = $(this)
            .closest('.ProductGridItemNew-actionsDesktop')
            .find('.js-ProductGridQuickView');
          TweenMax.to(the_quickshop_btn, 0.1, { autoAlpha: 0, display: 'none', ease: Power2.ease });
    
          console.log($(this).children().length);
          if ($(this).children().length == 1 && $(this).attr('data-bundle') === 'false'  ) {
            let the_options = $(this)
              .closest('.ProductGridItemNew')
              .find('.ProductGridItemNew-select > option:not(.ProductGridItemNew-option-label)')
              .clone();
            $(this).append(the_options);
          }
        });
    
    }


}